const CarouselBanner = {
  options: {
    data: {
      text: {
        type: 'Text',
        order: 0,
      },
      images: [
        {
          image: {
            src: '',
          },
          pointTo: {
            url: '',
            pointTo: '',
            pointToName: '',
            pointToType: '',
          },
        },
      ],
    },
    customization: {},
    widgets: {
      Menu_titleSettings: {
        order: 1,
        type: 'Menu',
        renderOptions: {
          controlKey: 'titleSettings',
        },
        options: {
          textSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 2,
          },
          textColor: {
            type: 'HexColor',
          },
          textStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 3,
          },
          textWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 4,
          },
          backgroundColor: {
            type: 'HexColor',
            order: 4,
          },
          textWordSpacing: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 5,
          },
          textLetterSpacing: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 6,
          },
        },
      },

      Menu_productTitleSettings: {
        type: 'Menu',
        order: 300,
        renderOptions: {
          controlKey: 'productTitleSettings',
        },
        options: {
          'widget.ToggleTabs_1': {
            type: 'ToggleTabs',
            order: 5,
            renderOptions: {
              controlKey: 'isShowProductTitle',
            },
            options: {
              productTextColor: {
                type: 'HexColor',
                order: 1,
              },
              productTextSize: {
                type: 'RangePx',
                data: {
                  max: 20,
                  min: 0,
                  step: 1,
                },
                order: 2,
              },
              productTextStyle: {
                type: 'SelectBox',
                data: {
                  selectOptions: ['normal', 'italic'],
                },
                order: 3,
              },
              productTextWeight: {
                type: 'SelectBox',
                data: {
                  selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
                },
                order: 4,
              },
            },
          },
        },
      },
      Menu_IndicatorSettings: {
        type: 'Menu',
        order: 1200,
        renderOptions: {
          controlKey: 'IndicatorSettings',
        },
        options: {
          indicator: {
            type: 'ChildComponentRenderer',
            order: 1,
            data: {
              componentNames: [
                'variant1',
                'variant2',
                'variant3',
                'variant4',
                'variant5',
                'variant6',
                'variant7',
                'variant8',
              ],
            },
          },
          activeIndicatorColor: {
            type: 'HexColor',
            order: 2,
          },
          inactiveIndicator: {
            type: 'HexColor',
            order: 3,
          },
        },
      },
      Menu_CarouselArrowsSettings: {
        type: 'Menu',
        order: 1200,
        renderOptions: {
          controlKey: 'CarouselArrowsSettings',
        },
        options: {
          isShowArrows: {
            type: 'Radio',
            order: 1,
            data: {
              direction: 'row',
              radioOptions: ['show', 'notShow'],
            },
          },
          isShowBackground: {
            type: 'Radio',
            order: 2,
            data: {
              direction: 'row',
              radioOptions: ['show', 'notShow'],
            },
          },
          carouselArrowsBackgroundColor: {
            type: 'HexColor',
            order: 3,
          },
          carouselArrowsColor: {
            type: 'HexColor',
            order: 4,
          },
          carouselArrowsBorderColor: {
            type: 'HexColor',
            order: 5,
          },
          distanceToTheCorner: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 6,
          },
          distanceToTop: {
            data: {
              max: 60,
              min: 0,
              step: 1,
            },
            type: 'RangeNumber',
            order: 7,
          },
          carouselArrowsBackgroundColorBorderRadius: {
            data: {
              max: 30,
              min: 0,
              step: 1,
              svgType: 'border',
            },
            type: 'FourPx',
            order: 7,
          },
          carouselArrowSize: {
            type: 'RangePx',
            data: {
              max: 52,
              min: 12,
              step: 1,
            },
            order: 8,
          },
        },
      },
      Menu_GeneralSettings: {
        type: 'Menu',
        order: 1300,
        renderOptions: {
          controlKey: 'OtherSettings',
        },
        options: {
          backgroundSize: {
            type: 'Radio',
            order: 10,
            data: {
              direction: 'row',
              radioOptions: ['cover', 'contain', 'stretch'],
            },
          },
          'widget.Tabs_1': {
            type: 'Tabs',
            order: 13,
            options: {
              containerPadding: {
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                  svgType: 'edge',
                },
                type: 'FourPx',
              },
              padding: {
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                  svgType: 'edge',
                },
                type: 'FourPx',
              },
              borderRadius: {
                data: {
                  max: 50,
                  min: 0,
                  step: 1,
                  svgType: 'border',
                },
                type: 'FourPx',
              },
            },
          },
          'widget.ToggleRadioTabs_1': {
            type: 'ToggleRadioTabs',
            order: 14,
            renderOptions: {
              controlKey: 'backgroundType',
              direction: 'row',
            },
            options: {
              backgroundImage: {
                type: 'ImageUploader',
              },
              backgroundColor: {
                type: 'HexColor',
              },
            },
          },
          productTitleMarginBottom: {
            type: 'RangePx',
            order: 15,
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
          },
          boxShadow: {
            type: 'ChildComponentRenderer',
            order: 26,
            data: {
              componentNames: ['shadow1', 'shadow2', 'shadow3'],
            },
          },
          imageWidth: {
            data: {
              max: 100,
              min: 30,
              step: 5,
            },
            type: 'RangeNumber',
          },
        },
      },
    },
  },
  variants: [
    {
      id: 'CarouselBanner_1_1',
      name: 'CarouselBanner_1_1',
      type: 'CarouselBanner',
      data: {
        text: '',
        images: [],
      },
      customization: {
        padding: '10px 0px 0px 0px',
        textSize: '12px',
        boxShadow: false,
        indicator: 'variant7',
        textColor: '#7059ef',
        textStyle: 'normal',
        textWeight: '100',
        borderRadius: '0px 0px 0px 0px',
        textAlignment: 'left',
        backgroundSize: 'cover',
        backgroundType: '-',
        backgroundColor: '#F0EEFB',
        backgroundImage: '',
        containerPadding: '0px 0px 0px 0px',
        textLetterSpacing: '0px',
        isShowBackground: 'notShow',
        isShowArrows: 'notShow',
        carouselArrowsBackgroundColor: '#F0EEFC',
        carouselArrowsColor: '#000000',
        distanceToTheCorner: '10px',
        distanceToTop: '47',
        carouselArrowsBackgroundColorBorderRadius: '30px 30px 30px 30px',
        carouselArrowsBorderColor: '#F0EEFC',
        carouselArrowSize: '24px',
        activeIndicatorColor: '#000000',
        inactiveIndicator: '#F0EEFC',
        isShowProductTitle: false,
        productTextColor: '#000000',
        productTextSize: '12px',
        productTextStyle: 'normal',
        productTextWeight: '400',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 2,
        maxImage: 10,
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Karosel+Banner+1_1.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'CarouselBanner_1_1_full',
      name: 'CarouselBanner_1_1_full',
      type: 'CarouselBanner',
      data: {
        text: '',
        images: [],
      },
      customization: {
        padding: '10px 10px 0px 10px',
        textSize: '12px',
        boxShadow: false,
        indicator: 'variant7',
        textColor: '#7059ef',
        textStyle: 'normal',
        textWeight: '100',
        borderRadius: '0px 0px 0px 0px',
        textAlignment: 'left',
        backgroundSize: 'cover',
        backgroundType: '-',
        backgroundColor: '#F0EEFB',
        backgroundImage: '',
        containerPadding: '0px 0px 0px 0px',
        textLetterSpacing: '0px',
        isShowBackground: 'notShow',
        isShowArrows: 'notShow',
        carouselArrowsBackgroundColor: '#F0EEFC',
        carouselArrowsColor: '#000000',
        distanceToTheCorner: '10px',
        distanceToTop: '47',
        carouselArrowsBackgroundColorBorderRadius: '30px 30px 30px 30px',
        carouselArrowsBorderColor: '#F0EEFC',
        carouselArrowSize: '24px',
        activeIndicatorColor: '#000000',
        inactiveIndicator: '#F0EEFC',
        isShowProductTitle: false,
        productTextColor: '#000000',
        productTextSize: '12px',
        productTextStyle: 'normal',
        productTextWeight: '400',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 2,
        maxImage: 10,
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Karosel+Banner+1_1-1.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'CarouselBanner_1_4_2_full',
      name: 'CarouselBanner_1_4_2_full',
      type: 'CarouselBanner',
      data: {
        text: '',
        images: [],
      },
      customization: {
        borderRadius: '0px 0px 0px 0px',
        textAlignment: 'left',
        textSize: '12px',
        textColor: '#7059ef',
        textStyle: 'normal',
        textWeight: '100',
        backgroundColor: '#F0EEFB',
        textLetterSpacing: '0px',
        containerPadding: '0px 0px 0px 0px',
        padding: '0px 0px 0px 0px',
        boxShadow: 'shadow1',
        backgroundImage: '',
        backgroundType: '-',
        backgroundSize: 'cover',
        indicator: 'variant1',
        isShowBackground: 'notShow',
        isShowArrows: 'notShow',
        carouselArrowsBackgroundColor: '#F0EEFC',
        carouselArrowsColor: '#000000',
        distanceToTheCorner: '10px',
        distanceToTop: '47',
        carouselArrowsBackgroundColorBorderRadius: '30px 30px 30px 30px',
        carouselArrowsBorderColor: '#F0EEFC',
        carouselArrowSize: '24px',
        activeIndicatorColor: '#000000',
        inactiveIndicator: '#F0EEFC',
        isShowProductTitle: false,
        productTextColor: '#000000',
        productTextSize: '12px',
        productTextStyle: 'normal',
        productTextWeight: '400',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '14/20',
        minImage: 2,
        maxImage: 10,
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Karosel+Banner+1.4_2.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'CarouselBanner_1_5_1_full',
      name: 'CarouselBanner_1_5_1_full',
      type: 'CarouselBanner',
      data: {
        text: '',
        images: [],
      },
      customization: {
        padding: '10px 10px 0px 10px',
        textSize: '12px',
        boxShadow: false,
        indicator: 'variant7',
        textColor: '#7059ef',
        textStyle: 'normal',
        textWeight: '100',
        borderRadius: '0px 0px 0px 0px',
        textAlignment: 'left',
        backgroundSize: 'cover',
        backgroundType: '-',
        backgroundColor: '#F0EEFB',
        backgroundImage: '',
        containerPadding: '0px 0px 0px 0px',
        textLetterSpacing: '0px',
        isShowBackground: 'notShow',
        isShowArrows: 'notShow',
        carouselArrowsBackgroundColor: '#F0EEFC',
        carouselArrowsColor: '#000000',
        distanceToTheCorner: '10px',
        distanceToTop: '47',
        carouselArrowsBackgroundColorBorderRadius: '30px 30px 30px 30px',
        carouselArrowsBorderColor: '#F0EEFC',
        carouselArrowSize: '24px',
        activeIndicatorColor: '#000000',
        inactiveIndicator: '#F0EEFC',
        isShowProductTitle: false,
        productTextColor: '#000000',
        productTextSize: '12px',
        productTextStyle: 'normal',
        productTextWeight: '400',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '3/2',
        minImage: 2,
        maxImage: 10,
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Karosel+Banner+(1.5_1).png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'CarouselBanner_1_5_1',
      name: 'CarouselBanner_1_5_1',
      type: 'CarouselBanner',
      data: {
        text: '',
        images: [],
      },
      customization: {
        padding: '10px 0px 0px 0px',
        textSize: '12px',
        boxShadow: false,
        indicator: 'variant7',
        textColor: '#7059ef',
        textStyle: 'normal',
        textWeight: '100',
        borderRadius: '0px 0px 0px 0px',
        textAlignment: 'left',
        backgroundSize: 'cover',
        backgroundType: '-',
        backgroundColor: '#F0EEFB',
        backgroundImage: '',
        containerPadding: '0px 0px 0px 0px',
        textLetterSpacing: '0px',
        isShowBackground: 'notShow',
        isShowArrows: 'notShow',
        carouselArrowsBackgroundColor: '#F0EEFC',
        carouselArrowsColor: '#000000',
        distanceToTheCorner: '10px',
        distanceToTop: '47',
        carouselArrowsBackgroundColorBorderRadius: '30px 30px 30px 30px',
        carouselArrowsBorderColor: '#F0EEFC',
        carouselArrowSize: '24px',
        activeIndicatorColor: '#000000',
        inactiveIndicator: '#F0EEFC',
        isShowProductTitle: false,
        productTextColor: '#000000',
        productTextSize: '12px',
        productTextStyle: 'normal',
        productTextWeight: '400',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '3/2',
        minImage: 2,
        maxImage: 10,
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Karosel+Banner+1.5_1.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'CarouselBanner_1_5_2',
      name: 'CarouselBanner_1_5_2',
      type: 'CarouselBanner',
      data: {
        text: '',
        images: [],
      },
      customization: {
        borderRadius: '0px 0px 0px 0px',
        textAlignment: 'left',
        textSize: '12px',
        textColor: '#7059ef',
        textStyle: 'normal',
        textWeight: '100',
        backgroundColor: '#F0EEFB',
        textLetterSpacing: '0px',
        containerPadding: '0px 0px 0px 0px',
        padding: '0px 0px 0px 0px',
        boxShadow: 'shadow1',
        backgroundImage: '',
        backgroundType: '-',
        backgroundSize: 'cover',
        indicator: 'variant1',
        isShowBackground: 'notShow',
        isShowArrows: 'notShow',
        carouselArrowsBackgroundColor: '#F0EEFC',
        carouselArrowsColor: '#000000',
        distanceToTheCorner: '10px',
        distanceToTop: '47',
        carouselArrowsBackgroundColorBorderRadius: '30px 30px 30px 30px',
        carouselArrowsBorderColor: '#F0EEFC',
        carouselArrowSize: '24px',
        activeIndicatorColor: '#000000',
        inactiveIndicator: '#F0EEFC',
        isShowProductTitle: false,
        productTextColor: '#000000',
        productTextSize: '12px',
        productTextStyle: 'normal',
        productTextWeight: '400',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '3/4',
        minImage: 2,
        maxImage: 10,
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Karosel+Banner+1.5_2-1.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'CarouselBanner_1_5_2_bigger',
      name: 'CarouselBanner_1_5_2_bigger',
      type: 'CarouselBanner',
      data: {
        text: '',
        images: [],
      },
      customization: {
        borderRadius: '0px 0px 0px 0px',
        textAlignment: 'left',
        textSize: '12px',
        textColor: '#7059ef',
        textStyle: 'normal',
        textWeight: '100',
        backgroundColor: '#F0EEFB',
        textLetterSpacing: '0px',
        containerPadding: '0px 0px 0px 0px',
        padding: '0px 0px 0px 0px',
        boxShadow: 'shadow1',
        backgroundImage: '',
        backgroundType: '-',
        backgroundSize: 'cover',
        indicator: 'variant1',
        isShowBackground: 'notShow',
        isShowArrows: 'notShow',
        carouselArrowsBackgroundColor: '#F0EEFC',
        carouselArrowsColor: '#000000',
        distanceToTheCorner: '10px',
        distanceToTop: '47',
        carouselArrowsBackgroundColorBorderRadius: '30px 30px 30px 30px',
        carouselArrowsBorderColor: '#F0EEFC',
        carouselArrowSize: '24px',
        activeIndicatorColor: '#000000',
        inactiveIndicator: '#F0EEFC',
        isShowProductTitle: false,
        productTextColor: '#000000',
        productTextSize: '12px',
        productTextStyle: 'normal',
        productTextWeight: '400',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '3/4',
        minImage: 2,
        maxImage: 10,
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Karosel+Banner+1.5_2.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'CarouselBanner_1_6_1',
      name: 'CarouselBanner_1_6_1',
      type: 'CarouselBanner',
      data: {
        text: '',
        images: [],
      },
      customization: {
        borderRadius: '0px 0px 0px 0px',
        textAlignment: 'left',
        textSize: '12px',
        textColor: '#7059ef',
        textStyle: 'normal',
        textWeight: '100',
        backgroundColor: '#F0EEFB',
        textLetterSpacing: '0px',
        containerPadding: '0px 0px 0px 0px',
        padding: '0px 0px 0px 0px',
        boxShadow: 'shadow1',
        backgroundImage: '',
        backgroundType: '-',
        backgroundSize: 'cover',
        indicator: 'variant1',
        isShowBackground: 'notShow',
        isShowArrows: 'notShow',
        carouselArrowsBackgroundColor: '#F0EEFC',
        carouselArrowsColor: '#000000',
        distanceToTheCorner: '10px',
        distanceToTop: '47',
        carouselArrowsBackgroundColorBorderRadius: '30px 30px 30px 30px',
        carouselArrowsBorderColor: '#F0EEFC',
        carouselArrowSize: '24px',
        activeIndicatorColor: '#000000',
        inactiveIndicator: '#F0EEFC',
        isShowProductTitle: false,
        productTextColor: '#000000',
        productTextSize: '12px',
        productTextStyle: 'normal',
        productTextWeight: '400',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '16/10',
        minImage: 2,
        maxImage: 10,
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Karosel+Banner+(1.6_1).png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'CarouselBanner_1_6_2',
      name: 'CarouselBanner_1_6_2',
      type: 'CarouselBanner',
      data: {
        text: '',
        images: [],
      },
      customization: {
        borderRadius: '0px 0px 0px 0px',
        textAlignment: 'left',
        textSize: '12px',
        textColor: '#7059ef',
        textStyle: 'normal',
        textWeight: '100',
        backgroundColor: '#F0EEFB',
        textLetterSpacing: '0px',
        containerPadding: '0px 0px 0px 0px',
        padding: '0px 0px 0px 0px',
        boxShadow: 'shadow1',
        backgroundImage: '',
        backgroundType: '-',
        backgroundSize: 'cover',
        indicator: 'variant1',
        isShowBackground: 'notShow',
        isShowArrows: 'notShow',
        carouselArrowsBackgroundColor: '#F0EEFC',
        carouselArrowsColor: '#000000',
        distanceToTheCorner: '10px',
        distanceToTop: '47',
        carouselArrowsBackgroundColorBorderRadius: '30px 30px 30px 30px',
        carouselArrowsBorderColor: '#F0EEFC',
        carouselArrowSize: '24px',
        activeIndicatorColor: '#000000',
        inactiveIndicator: '#F0EEFC',
        isShowProductTitle: false,
        productTextColor: '#000000',
        productTextSize: '12px',
        productTextStyle: 'normal',
        productTextWeight: '400',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '16/20',
        minImage: 2,
        maxImage: 10,
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Karosel+Banner+1.6_2.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'CarouselBanner_2_5_1',
      name: 'CarouselBanner_2_5_1',
      type: 'CarouselBanner',
      data: {
        text: '',
        images: [],
      },
      customization: {
        borderRadius: '0px 0px 0px 0px',
        textAlignment: 'left',
        textSize: '12px',
        textColor: '#7059ef',
        textStyle: 'normal',
        textWeight: '100',
        backgroundColor: '#F0EEFB',
        textLetterSpacing: '0px',
        containerPadding: '0px 0px 0px 0px',
        padding: '0px 0px 0px 0px',
        boxShadow: 'shadow1',
        backgroundImage: '',
        backgroundType: '-',
        backgroundSize: 'cover',
        indicator: 'variant1',
        isShowBackground: 'notShow',
        isShowArrows: 'notShow',
        carouselArrowsBackgroundColor: '#F0EEFC',
        carouselArrowsColor: '#000000',
        distanceToTheCorner: '10px',
        distanceToTop: '47',
        carouselArrowsBackgroundColorBorderRadius: '30px 30px 30px 30px',
        carouselArrowsBorderColor: '#F0EEFC',
        carouselArrowSize: '24px',
        activeIndicatorColor: '#000000',
        inactiveIndicator: '#F0EEFC',
        isShowProductTitle: false,
        productTextColor: '#000000',
        productTextSize: '12px',
        productTextStyle: 'normal',
        productTextWeight: '400',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '5/2',
        minImage: 2,
        maxImage: 10,
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Karosel+Banner+2.5_1+(2).png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'CarouselBanner_dynamic',
      name: 'CarouselBanner_dynamic',
      type: 'CarouselBanner',
      data: {
        text: '',
        images: [],
      },
      customization: {
        borderRadius: '0px 0px 0px 0px',
        textAlignment: 'left',
        textSize: '12px',
        textColor: '#7059ef',
        textStyle: 'normal',
        textWeight: '100',
        backgroundColor: '#F0EEFB',
        textLetterSpacing: '0px',
        containerPadding: '0px 0px 0px 0px',
        padding: '0px 0px 0px 0px',
        boxShadow: 'shadow1',
        backgroundImage: '',
        backgroundType: '-',
        indicator: 'variant1',
        isShowBackground: 'notShow',
        isShowArrows: 'notShow',
        carouselArrowsBackgroundColor: '#F0EEFC',
        carouselArrowsColor: '#000000',
        distanceToTheCorner: '10px',
        carouselArrowsBackgroundColorBorderRadius: '30px 30px 30px 30px',
        carouselArrowsBorderColor: '#F0EEFC',
        carouselArrowSize: '24px',
        activeIndicatorColor: '#000000',
        inactiveIndicator: '#F0EEFC',
        isShowProductTitle: false,
        productTextColor: '#000000',
        productTextSize: '12px',
        productTextStyle: 'normal',
        productTextWeight: '400',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1',
        minImage: 2,
        maxImage: 10,
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/singleBannerFullDynamic.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'CarouselBanner_1_1_small',
      name: 'CarouselBanner_1_1_small',
      type: 'CarouselBanner',
      data: {
        text: '',
        images: [],
      },
      customization: {
        borderRadius: '0px 0px 0px 0px',
        textAlignment: 'left',
        textSize: '12px',
        textColor: '#7059ef',
        textStyle: 'normal',
        textWeight: '100',
        backgroundColor: '#F0EEFB',
        textLetterSpacing: '0px',
        containerPadding: '0px 0px 0px 0px',
        padding: '10px 10px 10px 10px',
        boxShadow: 'shadow1',
        backgroundImage: '',
        backgroundType: '-',
        backgroundSize: 'cover',
        indicator: 'variant1',
        isShowBackground: 'show',
        isShowArrows: 'show',
        carouselArrowsBackgroundColor: '#F0EEFC',
        carouselArrowsColor: '#000000',
        distanceToTheCorner: '10px',
        distanceToTop: '47',
        carouselArrowsBackgroundColorBorderRadius: '30px 30px 30px 30px',
        carouselArrowsBorderColor: '#F0EEFC',
        carouselArrowSize: '24px',
        activeIndicatorColor: '#000000',
        inactiveIndicator: '#F0EEFC',
        isShowProductTitle: true,
        productTextColor: '#000000',
        productTextSize: '12px',
        productTextStyle: 'normal',
        productTextWeight: '400',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1',
        minImage: 4,
        maxImage: 10,
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Karosel+Banner+2.5_1+(2).png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'CarouselBanner_1_1_small_rounded',
      name: 'CarouselBanner_1_1_small_rounded',
      type: 'CarouselBanner',
      data: {
        text: '',
        images: [],
      },
      customization: {
        borderRadius: '50px 50px 50px 50px',
        textAlignment: 'left',
        textSize: '12px',
        textColor: '#7059ef',
        textStyle: 'normal',
        textWeight: '100',
        backgroundColor: '#F0EEFB',
        textLetterSpacing: '0px',
        containerPadding: '0px 0px 0px 0px',
        padding: '10px 10px 10px 10px',
        boxShadow: 'shadow1',
        backgroundImage: '',
        backgroundType: '-',
        backgroundSize: 'cover',
        indicator: 'variant1',
        isShowBackground: 'show',
        isShowArrows: 'show',
        carouselArrowsBackgroundColor: '#F0EEFC',
        carouselArrowsColor: '#000000',
        distanceToTheCorner: '10px',
        distanceToTop: '30',
        carouselArrowsBackgroundColorBorderRadius: '30px 30px 30px 30px',
        carouselArrowsBorderColor: '#F0EEFC',
        carouselArrowSize: '24px',
        activeIndicatorColor: '#000000',
        inactiveIndicator: '#F0EEFC',
        isShowProductTitle: true,
        productTextColor: '#000000',
        productTextSize: '12px',
        productTextStyle: 'normal',
        productTextWeight: '400',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1',
        minImage: 4,
        maxImage: 10,
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/CarouselBanner_1_1_small_rounded.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
  ],
  globalSettings: {
    canUploadVideo: true,
  },
};
export default CarouselBanner;
